import { render, staticRenderFns } from "./QualitySVG.vue?vue&type=template&id=50979b60&"
import script from "./QualitySVG.vue?vue&type=script&lang=js&"
export * from "./QualitySVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports